// CareLogix ORACLE — Frontend API client (typed-ish axios wrapper, with auth).
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_LS = "carelogix_oracle_token";

export function setAuthToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_LS, token);
    else localStorage.removeItem(TOKEN_LS);
  } catch { /* ignore */ }
}

export function getAuthToken() {
  try {
    return localStorage.getItem(TOKEN_LS) || null;
  } catch {
    return null;
  }
}

const http = axios.create({
  baseURL: API,
  timeout: 120000,
});

http.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const oracleApi = {
  health: () => http.get("/"),
  modes: () => http.get("/oracle/modes"),

  chat: ({ mode, messages, session_id, user_id }) =>
    http.post("/oracle/chat", { mode, messages, session_id, user_id }),

  // sessions
  listSessions: (userId) =>
    http.get("/oracle/sessions", { params: { user_id: userId } }),
  getSession: (sessionId) => http.get(`/oracle/sessions/${sessionId}`),
  createSession: (payload) => http.post("/oracle/sessions", payload),
  patchSession: (sessionId, payload) =>
    http.patch(`/oracle/sessions/${sessionId}`, payload),
  deleteSession: (sessionId) => http.delete(`/oracle/sessions/${sessionId}`),
  history: (sessionId, mode) =>
    http.get(`/oracle/history/${sessionId}`, { params: { mode } }),

  // watchlist
  watchlistAdd: (payload) => http.post("/oracle/watchlist", payload),
  watchlistList: (userId) => http.get(`/oracle/watchlist/${userId}`),
  watchlistDelete: (id) => http.delete(`/oracle/watchlist/${id}`),

  // live data
  liveStatus: () => http.get("/oracle/live/status"),
  oandaPrice: (instrument) =>
    http.get("/oracle/live/oanda/price", { params: { instrument } }),
  stockQuote: (symbol) =>
    http.get("/oracle/live/stocks/quote", { params: { symbol } }),
  cryptoQuote: (symbol) =>
    http.get("/oracle/live/crypto/quote", { params: { symbol } }),
  snapshot: (symbol, mode) =>
    http.get("/oracle/live/snapshot", { params: { symbol, mode } }),

  // admin
  adminStatus: () => http.get("/oracle/admin/status"),
  diagnostics: () => http.get("/oracle/diagnostics"),

  // auth
  authRegister: (payload) => http.post("/oracle/auth/register", payload),
  authLogin: (payload) => http.post("/oracle/auth/login", payload),
  authMe: () => http.get("/oracle/auth/me"),

  // intel
  graphTop: (limit = 10) => http.get("/oracle/graph/top", { params: { limit } }),
  graphAsset: (symbol) => http.get(`/oracle/graph/asset/${encodeURIComponent(symbol)}`),
  alertsList: (userId, onlyUnread = false) =>
    http.get(`/oracle/alerts/${userId}`, { params: { only_unread: onlyUnread } }),
  alertRead: (alertId) => http.post(`/oracle/alerts/${alertId}/read`),

  // pdf export (returns a Blob via fetch in caller)
  exportPdfUrl: (sessionId, mode) =>
    `${API}/oracle/export/${sessionId}?mode=${encodeURIComponent(mode)}`,

  // Global Intelligence Chyron™ (public)
  chyron: (limit = 30) => http.get("/oracle/chyron", { params: { limit } }),
};
